import React from "react";
import { Helmet } from "react-helmet-async";
import Layout from "../../../components/Layout/layout";
import { HeaderType } from "../../../components/Layout/header";
import Metrics from "../../../components/metrics";
import ProtectedRoute from "../../../../Auth/components/ProtectedRoute";

const SuperadminMetricsContainer = () => (
  <ProtectedRoute>
    <main>
    <Helmet title="Metrics" />
    <Layout headerType={HeaderType.superadmin}>
      <Metrics superAdminMetrics={true} />
    </Layout>
    </main>
  </ProtectedRoute>
);

export default SuperadminMetricsContainer;
